import { DefaultService } from "@/api/SolarCloudApi";
import { QueryConfig } from "@/lib/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export function getActiveCountriesQueryOptions() {
  return queryOptions({
    queryKey: ["countries", "active"],
    queryFn: () => getActiveCountries(),
    staleTime: Infinity,
  });
}

async function getActiveCountries() {
  const countries = await DefaultService.countryInfoSearchActive();
  return countries;
}

type UseActiveCountriesOptions = {
  queryConfig?: QueryConfig<typeof getActiveCountriesQueryOptions>;
};

export function useActiveCountries({ queryConfig }: UseActiveCountriesOptions = {}) {
  return useQuery({
    ...getActiveCountriesQueryOptions(),
    ...queryConfig,
  });
}